/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import List from '@ckeditor/ckeditor5-list/src/list';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { icons } from 'ckeditor5/src/core';
export default class AI extends Plugin {
	init() {
		const editor = this.editor;
// @ts-ignore
		editor.ui.componentFactory.add( 'ai', () => {
			// The button will be an instance of ButtonView.
			const button = new ButtonView();

			button.set( {
				label: '',
			 	  icon:'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n' +
					  '\t<defs> \n' +
					  '\t\t<linearGradient id="linear-gradient" y1="20" x2="20" gradientUnits="userSpaceOnUse">\n' +
					  '\t\t\t<stop offset="0" stop-color="#4b81fc"/>\n' +
					  '\t\t\t<stop offset="1" stop-color="#9c77fe"/>\n' +
					  '\t\t</linearGradient>\n' +
					  '\t</defs>\n' +
					  '\t<rect id="圆角矩形_1" data-name="圆角矩形 1" class="cls-1" style="fill: url(#linear-gradient)" width="20" height="20" rx="4" ry="4"/>\n' +
					  '\t<path id="矩形_4" data-name="矩形 4" class="cls-2" style="fill: #fff;fill-rule: evenodd;" d="M11,15l-0.6-2H6.6L6,15H4L7,5h3l3,10H11ZM8.9,8H8.1L7.2,11H9.8ZM14,5h2V15H14V5Z"/>\n' +
					  '</svg>',
				withText: true,
				class:'ck-ai-button'
			} );

			//Execute a callback function when the button is clicked
			button.on('execute', () => {
				const model = this.editor.model;
				const now = new Date().getTime();
				// @ts-ignore
				openAI(now,model,this.editor)
			} );

			return button;
		} );
	}
}

